export const models = {
  person: import.meta.env.VITE_PERSON_MODEL_ID as string,
  organization: import.meta.env.VITE_ORGANIZATION_MODEL_ID as string,
};
